import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import MenuTop from '../components/Admin/MenuTop';
import MenuSider from '../components/Admin/MenuSider';
import AdminSignIn from '../pages/Admin/SignIn';

import '../assets/css/sb-admin-2.min.css';
// import '../assets/css/modal.css';

export default function LayoutAdmin(props) {
    const {routes} = props;
    const { user, isLoading } = useAuth();
    
    if (!user && !isLoading){
      localStorage.removeItem('id');
      return (
        <>
          <Route path="/admin/login" component={AdminSignIn} />
          <Redirect to="/admin/login" />
        </>
      )
    }

    if(user && !isLoading) {
      localStorage.setItem('id', user.id);
      return (
        <div id="wrapper">
          <MenuSider 
          />
            <div id="content-wrapper" className="d-flex flex-column">
              <div id="content">
                <MenuTop
                  user={user}
                />
                <div className="container-fluid">
                  <LoadRoutes routes={routes} />
              </div>
            </div>
          </div>
        </div>
      );
    }
    
    return null;
}

function LoadRoutes({ routes }){
    return (
      <Switch>
        {routes.map((route, index) => (
          <Route 
            key={index}
            path={route.path}
            exact={route.exact}
            component={route.component}
          />
        ))}
      </Switch>
    );
}